import type { TFunction } from 'i18next';

/**
 * The label keys the invoice detail export names (SDD-020 §8.3, prompt 28 Decision 6). The
 * service publishes the same list in api/exports/; a unit test fails when they differ, and the
 * typed `t` fails the build when a key has no text.
 */
export const INVOICE_EXPORT_LABEL_KEYS = [
  'column.field',
  'column.lines.billingIntervalFrom',
  'column.lines.billingIntervalTo',
  'column.lines.grossAmount',
  'column.lines.itemType',
  'column.lines.name',
  'column.lines.netAmount',
  'column.lines.policyCode',
  'column.lines.pricePerUnit',
  'column.lines.quantity',
  'column.lines.taxAmount',
  'column.lines.taxRate',
  'column.value',
  'field.billingIntervalFrom',
  'field.billingIntervalTo',
  'field.code',
  'field.createdAt',
  'field.creditAmount',
  'field.currency',
  'field.dueDate',
  'field.grossAmount',
  'field.groupPolicyCode',
  'field.invoiceNumber',
  'field.netAmount',
  'field.openAmount',
  'field.paidAmount',
  'field.policyCode',
  'field.recipientPartnerId',
  'field.status',
  'field.taxAmount',
  'field.type',
  'sheet.header',
  'sheet.lines',
] as const;

export type InvoiceExportLabelKey = (typeof INVOICE_EXPORT_LABEL_KEYS)[number];

/** The `labels` map of the detail export, in the reader's language. */
export function buildInvoiceExportLabels(t: TFunction<'billing'>): Record<string, string> {
  return Object.fromEntries(
    INVOICE_EXPORT_LABEL_KEYS.map((key) => [key, t(`exportLabels.invoice.${key}`)]),
  );
}
